import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Footer from "../components/Footer";

const LegalLayout = ({ eyebrow, title, children, testId = "legal-page" }) => {
  return (
    <main className="bg-black text-white min-h-screen" data-testid={testId}>
      <div className="border-b border-white/10">
        <div className="max-w-[1500px] mx-auto px-6 md:px-12 lg:px-20 py-6 flex items-center justify-between">
          <Link
            to="/"
            className="font-heading text-white text-lg tracking-[0.25em] hover:text-[#c0392b] transition-colors"
            data-testid="legal-logo"
          >
            MIGUEL FARIA<span className="text-[#c0392b]">.</span>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-white/70 hover:text-[#c0392b] transition-colors font-heading text-xs tracking-[0.25em] uppercase"
            data-testid="legal-back"
          >
            <ArrowLeft size={14} /> Voltar ao Site
          </Link>
        </div>
      </div>

      <section className="max-w-[900px] mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-28">
        <div className="flex items-center gap-3 mb-6">
          <span className="divider-red" />
          <span className="font-heading text-[#c0392b] tracking-[0.4em] text-xs uppercase">
            {eyebrow}
          </span>
        </div>
        <h1
          className="font-heading text-white uppercase leading-[0.95] text-5xl md:text-7xl mb-12"
          data-testid="legal-title"
        >
          {title}
        </h1>
        <div className="space-y-8 text-white/85 text-base md:text-lg leading-relaxed">
          {children}
        </div>
        <p className="text-white/40 text-xs tracking-[0.3em] uppercase font-heading mt-16 pt-8 border-t border-white/15">
          Última atualização — 14 de Maio de 2026
        </p>
      </section>

      <Footer />
    </main>
  );
};

export default LegalLayout;
